import { useRef, useState } from 'react';

import type { FormEvent } from 'react';
import { Grid, Textfield, Alert, useMount } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core';

import { useCreateWatchlist } from '@/hooks/useWatchlistMutations';

export interface Props {
  onCancel: () => void;
  onSuccess: () => void;
}

const validateNewWatchlistName = (name: string) => {
  if (name.length > 254) {
    return 'Please enter a name less than 255 characters';
  }
  return '';
};

export const CreateWatchlist = ({ onSuccess, onCancel }: Props) => {
  const { mutate, status, error } = useCreateWatchlist({
    onSuccess,
  });

  const [name, setName] = useState('');
  const [nameValidation, setNameValidation] = useState('');
  const inputRef = useRef<null | HTMLInputElement>(null);

  useMount(() => {
    inputRef.current?.focus();
  });

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errorMessage = validateNewWatchlistName(name);
    if (errorMessage) {
      setNameValidation(errorMessage);
      return;
    }
    mutate({
      name,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid gap="24px">
        {status === 'error' && error instanceof Error && (
          <Alert styleType="negative">{error.message}</Alert>
        )}
        <Grid gap={nameValidation ? '24px' : '16px'}>
          <Textfield
            name="watchlistName"
            type="text"
            styleType="standardReverse"
            ref={inputRef}
            label="Watchlist Name"
            placeholder="e.g. My New Watchlist"
            disabled={status === 'pending'}
            onBlur={() => {
              if (name !== '') {
                setNameValidation(validateNewWatchlistName(name));
              }
            }}
            onFocus={() => {
              setNameValidation('');
            }}
            onChange={(evt) => {
              setName(evt.currentTarget.value);
            }}
            error={nameValidation}
            value={name}
          />
          <Grid
            templateColumns="max-content max-content"
            justifyContent="start"
          >
            <Button
              styleType="louderLarge"
              isLoading={status === 'pending'}
              disabled={status === 'pending'}
              type="submit"
            >
              Create Watchlist
            </Button>
            <Button
              onClick={onCancel}
              styleType="gentleLargeReverse"
              marginLeft
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
